import { useMemo, useState } from 'react'

import { useWindow, useQueryResult } from '@krp/client-runtime'
import { DeliveryWindow, attentionRowsOf, ownDeliveryAttention, useAgentSession, useDeliveryMonitor, type DeliveryServerState } from '@krp/resource-own-ui'

import { useAppDispatch } from '../../app/hooks'
import { AGENT_MIN_API_LEVEL } from '../platform/hardwareLinks'

/**
 * Окно «Доставка» источника «Собственная» (RP-OWN9): локальный отчёт кассового агента этого компьютера и ведомость центрального
 * журнала (что требует разбора). Только чтение: окно ничего не закрывает и не повторяет, денег не касается. rid — из адреса окна.
 */
export function OwnDeliveryBinding() {
  const window = useWindow()
  const resourceId = window.params.rid ?? ''
  const dispatch = useAppDispatch()
  const session = useAgentSession({ dispatch, minApiLevel: AGENT_MIN_API_LEVEL })
  const local = useDeliveryMonitor(session, { dispatch })
  const [showClosed, setShowClosed] = useState(false)
  const args = useMemo(() => (resourceId === '' ? null : { resourceId, openOnly: !showClosed }), [resourceId, showClosed])
  const query = useQueryResult(ownDeliveryAttention, args)

  if (resourceId === '') return <p role="alert">Не указан источник продажи.</p>

  const server: DeliveryServerState = query.isError
    ? {
        state: 'error',
        message: query.error !== undefined && 'message' in query.error ? String(query.error.message) : 'Ведомость сервера не прочитана.',
        code: query.error !== undefined && 'code' in query.error ? String(query.error.code) : null,
        status: query.error !== undefined && 'status' in query.error && typeof query.error.status === 'number' ? query.error.status : null,
        correlationId: query.error !== undefined && 'correlationId' in query.error ? String(query.error.correlationId) : null,
      }
    : query.data === undefined
      ? { state: 'loading' }
      : { state: 'ready', rows: attentionRowsOf(query.data) }

  return (
    <DeliveryWindow
      local={local.view}
      onRefreshLocal={local.refresh}
      server={server}
      showClosed={showClosed}
      onShowClosed={setShowClosed}
      onReloadServer={() => void dispatch(ownDeliveryAttention.initiate({ resourceId, openOnly: !showClosed }, { forceRefetch: true }))}
    />
  )
}
